import React from "react";
import PropTypes from "prop-types";
import { OnyxPageShell } from "./onyx/OnyxPageShell";

/**
 * App page layout — OnyxPageShell with app nav + legacy layout class hooks.
 */
export const PageLayout = ({
  children,
  className = "",
  announcement,
}) => {
  return (
    <OnyxPageShell
      withAppNav
      hideBrandHeader
      announcement={announcement}
      className={['page-layout', className].filter(Boolean).join(' ')}
    >
      <div className="page-layout__content">
        {children}
      </div>
    </OnyxPageShell>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  announcement: PropTypes.string,
};
